import { render, staticRenderFns } from "./HistoryCommentComponent.vue?vue&type=template&id=4723e604&scoped=true"
import script from "./HistoryCommentComponent.vue?vue&type=script&lang=js"
export * from "./HistoryCommentComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoryCommentComponent.vue?vue&type=style&index=0&id=4723e604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723e604",
  null
  
)

export default component.exports